import * as React from "react";
import { PropertyFiltersProps } from "./typings";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { MobilePropertyFilters } from "components/flexComponents/PropertyFilters/viewport/MobilePropertyFilters";
import { DesktopPropertyFilters } from "components/flexComponents/PropertyFilters/viewport/DesktopPropertyFilters";
import { usePropertySearchQuery } from "src/stores/PropertyFiltersStore/usePropertySearchQuery";
import { withStores } from "src/stores";
import { observer } from "mobx-react";

export const PROPERTY_FILTERS = "PropertyFilters";

export const PropertyFilters = withStores("propertyFilters")(
  observer((props: PropertyFiltersProps) => {
    const { flexComponent, context, propertyFilters } = props;
    const regionId = context?.searchContext?.location?.id;

    if (!flexComponent || !regionId) {
      return null;
    }

    const { data, error, loading } = usePropertySearchQuery(context);

    const response = data?.propertySearch.sortAndFilter.options?.sortAndFilter;

    if (error || loading || !response) {
      return <div data-testid="no-property-filters" />;
    }

    if (propertyFilters.isEmpty()) {
      propertyFilters.setFilters(response);
    }

    return (
      <div className="PropertyFilters uitk-cell all-cell-1-1" id={flexComponent.id}>
        <Viewport>
          <ViewSmall>
            <MobilePropertyFilters />
          </ViewSmall>
          <ViewLarge>
            <DesktopPropertyFilters />
          </ViewLarge>
        </Viewport>
      </div>
    );
  })
);

export default PropertyFilters;
